import { fetchApi } from '@/config/axiosSetting';
import {
  GetVisitFormDataQueryParamsType,
  GetVisitFormDataQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitFormData/getVisitFormDataQuery.type';

export const getVisitFormDataFunction = (
  params: GetVisitFormDataQueryParamsType,
): Promise<GetVisitFormDataQueryResponseType[]> => {
  return fetchApi.get(`/initial/reports/${params.id}/visit_form/`, { params });
};
